module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: [
      'el-input-number',
      'rt-input-number-icon',
      _vm.inputNumberSize ? 'el-input-number--' + _vm.inputNumberSize : '',
      {
        'is-disabled': _vm.inputNumberDisabled
      },
      {
        'is-without-controls': !_vm.controls
      },
      {
        'is-controls-right': _vm.controlsAtRight
      },
      {
        'is-controls-left': _vm.controlsAtLeft
      }
    ],
    on: {
      "dragstart": function($event) {
        $event.preventDefault();
      }
    }
  }, [(_vm.controls && !_vm.inputNumberDisabled) ? _c('span', {
    directives: [{
      name: "repeat-click",
      rawName: "v-repeat-click",
      value: (_vm.decrease),
      expression: "decrease"
    }],
    staticClass: "el-input-number__decrease",
    class: _vm.controlsMinAtStyle,
    attrs: {
      "role": "button"
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.decrease.apply(null, arguments)
      }
    }
  }, [_c('i', {
    class: ("el-icon-" + (_vm.controlsAtRight || _vm.controlsAtLeft ? 'arrow-down' : 'minus'))
  })]) : _vm._e(), _vm._v(" "), (_vm.controls && !_vm.inputNumberDisabled) ? _c('span', {
    directives: [{
      name: "repeat-click",
      rawName: "v-repeat-click",
      value: (_vm.increase),
      expression: "increase"
    }],
    staticClass: "el-input-number__increase",
    class: _vm.controlsMaxAtStyle,
    attrs: {
      "role": "button"
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.increase.apply(null, arguments)
      }
    }
  }, [_c('i', {
    class: ("el-icon-" + (_vm.controlsAtRight || _vm.controlsAtLeft ? 'arrow-up' : 'plus'))
  })]) : _vm._e(), _vm._v(" "), _c('el-input', {
    ref: "input",
    class: _vm.valueStyle,
    attrs: {
      "value": _vm.displayValue,
      "placeholder": _vm.placeholder,
      "disabled": _vm.inputNumberDisabled,
      "size": _vm.inputNumberSize,
      "max": _vm.max,
      "min": _vm.min,
      "name": _vm.name,
      "label": _vm.label
    },
    on: {
      "blur": _vm.handleBlur,
      "focus": _vm.handleFocus,
      "input": _vm.handleInput,
      "change": _vm.handleInputChange
    },
    nativeOn: {
      "keydown": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) { return null; }
        $event.preventDefault();
        return _vm.increase.apply(null, arguments)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) { return null; }
        $event.preventDefault();
        return _vm.decrease.apply(null, arguments)
      }]
    }
  }, [(!_vm.controls) ? _vm._t("prefix", function() {
    return [_vm._t("prefix")]
  }, {
    "slot": "prefix"
  }) : _vm._e(), _vm._v(" "), (!_vm.controls) ? _vm._t("suffix", function() {
    return [_vm._t("suffix")]
  }, {
    "slot": "suffix"
  }) : _vm._e()], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e6443e12"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/element-ui/packages/input-number/src/input-number.vue
// module id = 2230
// module chunks = 137